// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"tabContainer___1PV94","tabTitle":"tabTitle___3Gfc5","container":"container___2gQgm"};